import React, {Component} from 'react'
import { connect } from 'react-redux'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import { Oval } from 'react-loader-spinner'
import {actions as authActions} from '../../../redux/modules/Auth'
import { bindActionCreators } from 'redux'
import { reportActions } from 'redux/modules/Report' 
import BackOfficeSettingsMenuComponent from 'components/BackOfficeSettingsMenuComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import  * as solidIcons  from '@fortawesome/free-solid-svg-icons'
import  * as regularIcons  from '@fortawesome/free-regular-svg-icons'
import { ADMIN } from 'libs/roles'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import BackofficeEditVehiclePowerSupplyModal from '../../../components/Vehicles/BackofficeEditVehiclePowerSupplyModal';
import BackofficeEditVehiclePowerSupply from 'components/Vehicles/BackofficeEditVehiclePowerSupply'
import BackofficeEditVehicleOwnershipType from 'components/Vehicles/BackofficeEditVehicleOwnershipType'
import BackofficeEditVehicleOwnershipTypeModal from 'components/Vehicles/BackofficeEditVehicleOwnershipTypeModal'
import { scroller , Element } from 'react-scroll'

const POWERSUPPLY = 'POWERSUPPLY'
const OWNERSHIP   = 'OWNERSHIP'

/**
 * --------------------------------------------------------------------------
 * @param {*} state 
 * @returns 
 */
const mapStateToProps = (state) => {
  return {
    backofficeValues: state.form.backofficeSettings,
    auth: state.auth,
    stateReport : state.report   
  }
}

/**
 * --------------------------------------------------------------------------
 * @param {*} dispatch 
 * @returns 
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    authActions:   bindActionCreators(authActions,   dispatch),
    reportActions: bindActionCreators(reportActions, dispatch)
  }
}

/**
 * --------------------------------------------------------------------------
 */
class BackofficeSettingsVehicles extends Component {

  /**
   * --------------------------------------------------------------------------
   * @param {*} props 
   */
  constructor (props) {
    super(props)
    this.state = {
      success: false,
      loading: false,
      submitting: false,
      error: false,
      errorMsg: null,    
      items: [],
      selectedItemId: null,
      showEditDocumentTypeModal: false,      
      showMaximizedList: true,
      selectedFunction: POWERSUPPLY
    }
    
    this.onSave                 = this.onSave.bind(this)    
    this.editItem               = this.editItem.bind(this)
    this.onCloseEdit            = this.onCloseEdit.bind(this)    
    this.onCancelEdit           = this.onCancelEdit.bind(this)
    this.changeSelectedFunction = this.changeSelectedFunction.bind(this)
  }

  /**
   * --------------------------------------------------------------------------
   */
  async componentDidMount () {
    this.fetchData(this.state.selectedFunction)    
  }

  /**
   * --------------------------------------------------------------------------
   */
  async fetchData(selectedFunction) {
    this.setState({loading: true})

    if ( selectedFunction == POWERSUPPLY ) {      

      const items = await SostaOnlineApiService.fetchVehiclePowerSupplies()    
          
      if ( items != null && items.data != null  )
        this.setState({ items: items.data })

    }
    else if ( selectedFunction == OWNERSHIP ) {

      const items = await SostaOnlineApiService.fetchVehicleOwnershipTypes()    
          
      if ( items != null && items.data != null  )
        this.setState({ items: items.data })

    }

    this.fetchThingsToDo()
    this.setState({loading: false})
  }

  /**
   * --------------------------------------------------------------------------
   */
  fetchThingsToDo () {
    SostaOnlineApiService.fetchThingsToDo().then(data => {      
      this.props.reportActions.fetchThingsToDo(data.data)
    })
    .catch( error => {
      console.log("ERROR",error)
    })
  }   

  /**
   * --------------------------------------------------------------------------
   * @param {*} e 
   */
  async onSave (itemId) {        
    this.setState({submitting: true, error: null, success: false })
    await this.fetchData(this.state.selectedFunction)
    this.setState({submitting: false, error: false, success: true, selectedItemId: itemId})           
  }


  /**
   * --------------------------------------------------------------------------
   * @param {*} evt 
   */
  editItem(id) {    
    this.setState({
      selectedItemId: id,      
    })

    this.scrollToDetail()
  }


  /**
   * --------------------------------------------------------------------------
   * 
   */
  onCloseEdit() {
    this.setState({
      selectedItemId: null,
      showEditDocumentTypeModal: false
    })
  }

  /**
   * --------------------------------------------------------------------------
   */
  async onCancelEdit() {

  }


  /**
   * --------------------------------------------------------------------------
   */
  windowMaximize() {
    this.setState({ showEditDocumentTypeModal: true})
  }


  /**
   * --------------------------------------------------------------------------
   * @param {*} selectedFunction 
   */
  changeSelectedFunction(selectedFunction) {
    this.setState({ selectedFunction: selectedFunction })
    this.setState({
      selectedItemId: null,
      showEditDocumentTypeModal: false
    })
    this.fetchData(selectedFunction)    
  }

  /**
   * --------------------------------------------------------------
   * @param {*} element 
   */
  scrollToDetail() {
    scroller.scrollTo("detail", {
      duration: 1000,
      delay: 100,
      smooth: true
    })
  }


  /**
   * --------------------------------------------------------------------------
   * @returns 
   */
  render () {    

    const {
      success,
      loading,
      submitting,
      error,
      errorMsg,
      items,
      showEditDocumentTypeModal,
      selectedItemId,      
      showMaximizedList,
      selectedFunction
    } = this.state


    var itemsSorted = items.sort((a, b) => (a.id > b.id ) ? 1 : -1)


    if (loading) {
      return (
        <React.Fragment>
        <h3><strong>Caricamento in corso...</strong></h3>
        <div className="row" style={{padding: "2em", height: "40em"}}>
          <Oval secondaryColor="#02afff"  color="#174c88" height={40} width="100%" />                  
        </div>
        </React.Fragment>
      )
    } 
    if ( error )    {
      return (<div className="text-primary">{errorMsg}</div>)
    }

    if ( this.props.auth.user.role != ADMIN ) {
      return (<div className="text-primary">Utente non autorizzato</div>)
    }

    return (
      <React.Fragment>
        <BackOfficeSettingsMenuComponent {...this.props} />
        <div className="row">

          <div className="pull-left" style={{ margin: "1em" , marginTop: "1em" , marginRight: "0.1em" }}>
            <button className={ selectedFunction == POWERSUPPLY ? "selectedMainBtn" : "mainBtn" } onClick={ e => { this.changeSelectedFunction(POWERSUPPLY) } } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faGasPump} />
            <span className="hidden-xs hidden-sm">&nbsp;&nbsp;Tipi Alimentazione</span></button>
          </div>

          <div className="pull-left" style={{ margin: "0.1em" , marginTop: "1em"  }}>
            <button className={ selectedFunction == OWNERSHIP ? "selectedMainBtn" : "mainBtn" }  onClick={ e => { this.changeSelectedFunction(OWNERSHIP) } } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faPersonChalkboard} />
            <span className="hidden-xs hidden-sm">&nbsp;&nbsp;Tipi Proprietà</span></button>
          </div>

          { selectedFunction == POWERSUPPLY &&
          <div className="pull-left" style={{ margin: "0.1em" , marginTop: "1em"  }}>
            <button className="mainBtn" onClick={ e => { this.editItem(null) } } ><FontAwesomeIcon  size="1x" icon={solidIcons.faPlusCircle} />
            <span className="hidden-xs hidden-sm">&nbsp;&nbsp;Crea Tipo Alimentazione</span></button>
          </div>
          }

          { selectedFunction == OWNERSHIP &&
          <div className="pull-left" style={{ margin: "0.1em" , marginTop: "1em"  }}>
            <button className="mainBtn" onClick={ e => { this.editItem(null) } } ><FontAwesomeIcon  size="1x" icon={solidIcons.faPlusCircle} />
            <span className="hidden-xs hidden-sm">&nbsp;&nbsp;Crea Tipo Proprietà</span></button>
          </div>
          }
        </div>
        <div className="row" style={{  padding: 0,  margin: 0 }}>

          { showMaximizedList ?           
          <div className={ showEditDocumentTypeModal ? "box col-md-12" :  "box col-md-4" } style={{ padding: "0.3em", margin: 0 , marginBottom: "0.3em" }}>
            
            <div className="row backofficeSettingsHeader" >
              <div className="col-xs-2"><label>Id</label></div>
              <div className="col-xs-8"><label>Nome</label> </div>       
              <div className="col-xs-1 pull-right" style={{ verticalAlign: "middle"}}>
                 <FontAwesomeIcon  size="lg" className="mainIconsRev" icon={solidIcons.faCaretLeft} onClick={ () => { this.setState({showMaximizedList: false}) } } />
              </div>                  
            </div>
                      
            {itemsSorted.map(item =>              
              <OverlayTrigger key={`item-${item.id}`}  placement="top" overlay={<Tooltip id={'tooltip-item-'+item.id}>Clicca per modificare i dati  {  selectedFunction == POWERSUPPLY ? "del Tipo di Alimentazione" : "del Tipo di proprietà"}</Tooltip>}>
                <div className={ selectedItemId == item.id ? "backofficeSettingsRowSelected row" :  "backofficeSettingsRow row"}  >
                  <div className="col-xs-12 row">
                    <div className="col-xs-2" onClick={ evt => { this.editItem(item.id)} } ><label >{item.id}</label></div>                  
                    <div className="col-xs-8" onClick={ evt => { this.editItem(item.id)} } ><label >{item.name}</label></div>                  
                    <div className="col-xs-1 pull-right" style={{ verticalAlign: "middle"}}>{ selectedItemId == item.id ? <FontAwesomeIcon  size="lg" icon={solidIcons.faCaretRight} /> : "" }</div>
                  </div>
                </div>
              </OverlayTrigger>
            )}

            <div className="row backofficeSettingsFooter" >
              <div></div>
            </div>
          
            {submitting && <div className="text-primary col-xs-12 ">
              Salvataggio in corso
            </div>}

            {error && <div className="text-danger col-xs-12">
              Si sono verificati degli errori
            </div>}

            {success && <div className="text-success col-xs-12">
            
            </div>}
            
            
          </div>
          :
          <div className="col-md-1" style={{ padding: 0, margin: 0 , marginBottom: "0.3em" }}>
            <div className="mainBtn" onClick={ () => { this.setState({showMaximizedList: true}) } } >
              <FontAwesomeIcon  size="lg" icon={solidIcons.faCaretDown} />
            </div>
          </div>
          }
        
          { !showEditDocumentTypeModal && 
          <div className={ showMaximizedList ? "col-md-8": "col-md-11"} style={{  padding: "0.3em" , margin: 0 }}>
            <Element name="detail"/>
            <div className="backofficeSettingsBox" >
              <div className="backofficeSettingsBoxHeader row text-center">
                <div className="col-xs-1 pull-left">
                { selectedItemId != null 
                    ? <FontAwesomeIcon className="IconsRevNoAction"  size="1x" icon={solidIcons.faEdit} />
                    : <FontAwesomeIcon className="IconsRevNoAction"  size="1x" icon={solidIcons.faPlusCircle} />
                  }                
                </div>          
                <div className="col-xs-10 pull-left" >
                  { selectedFunction == POWERSUPPLY &&
                    <strong>{ selectedItemId != null ? "MODIFICA" : "CREA NUOVO" } TIPO DI ALIMENTAZIONE </strong>
                  }
                  { selectedFunction == OWNERSHIP &&
                    <strong>{ selectedItemId != null ? "MODIFICA" : "CREA NUOVO" } TIPO DI PROPRIETA' </strong>
                  }
                </div>
                <div className="col-xs-1 pull-right" onClick={ evt => this.windowMaximize() }>
                  <OverlayTrigger placement="left" overlay={<Tooltip id={"tooltip-category-to-window"}>Mostra in finestra</Tooltip>}>
                    <FontAwesomeIcon  size="1x" className="mainIconsRev" icon={solidIcons.faWindowRestore} />
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row" >
                { selectedFunction == POWERSUPPLY &&
                <BackofficeEditVehiclePowerSupply
                    vehiclePowerSupplyId={selectedItemId}
                    onSave={this.onSave}      
                    onDelete={this.onSave}    
                    onCancelEdit={this.onCancelEdit}
                    />
                }

                { selectedFunction == OWNERSHIP &&
                <BackofficeEditVehicleOwnershipType
                    vehicleOwnershipTypeId={selectedItemId}
                    onSave={this.onSave}      
                    onDelete={this.onSave}    
                    onCancelEdit={this.onCancelEdit}
                    />
                }
              </div>
            </div>
          </div>        
          }
        </div>
        
        { selectedFunction == POWERSUPPLY &&
        <BackofficeEditVehiclePowerSupplyModal
          show={showEditDocumentTypeModal}
          vehiclePowerSupplyId={selectedItemId}
          onSave={this.onSave}      
          onDelete={this.onSave}    
          onCancelEdit={this.onCancelEdit}
          onClose={this.onCloseEdit}
          />
        }

        { selectedFunction == OWNERSHIP &&
        <BackofficeEditVehicleOwnershipTypeModal
          show={showEditDocumentTypeModal}
          vehicleOwnershipTypeId={selectedItemId}
          onSave={this.onSave}      
          onDelete={this.onSave}    
          onCancelEdit={this.onCancelEdit}
          onClose={this.onCloseEdit}
          />
        }
        

      </React.Fragment>

      
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackofficeSettingsVehicles)
